import { jsxs as t, jsx as o } from "react/jsx-runtime";
const n = (r) => /* @__PURE__ */ t(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ...r,
    children: [
      /* @__PURE__ */ o(
        "path",
        {
          stroke: "currentcolor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: 2,
          d: "M10 12a2 2 0 1 0 4 0 2 2 0 0 0-4 0"
        }
      ),
      /* @__PURE__ */ o(
        "path",
        {
          stroke: "currentcolor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: 2,
          d: "M22 12q-4 7-10 7T2 12q4-7 10-7t10 7"
        }
      )
    ]
  }
);
export {
  n as default
};
